// src/components/ui/Badge.jsx
export function Badge({ children, color = "slate", className = "" }) {
  const colors = {
    slate: "bg-slate-100 dark:bg-slate-800 text-slate-700 dark:text-slate-300",
    green: "bg-green-100 dark:bg-emerald-500/10 text-green-700 dark:text-emerald-400",
    amber: "bg-amber-100 dark:bg-amber-500/10 text-amber-700 dark:text-amber-400",
    red: "bg-rose-100 dark:bg-rose-500/10 text-rose-700 dark:text-rose-400",
    indigo: "bg-indigo-100 dark:bg-indigo-500/10 text-indigo-700 dark:text-indigo-400",
    blue: "bg-sky-100 dark:bg-sky-500/10 text-sky-700 dark:text-sky-400",
    purple: "bg-purple-100 dark:bg-purple-500/10 text-purple-700 dark:text-purple-400",
  };

  return (
    <span
      className={[
        "inline-flex items-center rounded-full px-2 py-1 text-xs font-semibold",
        colors[color] || colors.slate,
        className,
      ].join(" ")}
    >
      {children}
    </span>
  );
}